document.addEventListener("DOMContentLoaded", function() {
  const footers = document.querySelectorAll(".sub-footer p");
  const decoder = new TextDecoder("utf-8");

  const checkB64 = "YmFscCBkaWppdGFs";
  const checkText = decoder
    .decode(Uint8Array.from(atob(checkB64), c=>c.charCodeAt(0)))
    .toLowerCase();

  const msgB64 = "QkFMUCBEaWppdGFsIHRhcmFmxLFuZGFuIHlhcMSxbG3EscWfdMSxcg=="; 
  
  const hrefB64 = "aHR0cHM6Ly9iYWxwZGlqaXRhbC5jb20=";

  footers.forEach(function(f) {
    if (!f.innerText.toLowerCase().includes(checkText)) {
      const msg = decoder.decode(Uint8Array.from(atob(msgB64), c=>c.charCodeAt(0)));
      const href = decoder.decode(Uint8Array.from(atob(hrefB64), c=>c.charCodeAt(0)));

      const span = document.createElement("span");
      const a    = document.createElement("a");
      a.className   = "sleep";
      a.href        = href;
      a.target      = "_blank";
      a.rel         = "noopener noreferrer";
      a.textContent = msg;

      span.append(" – ", a);
      f.appendChild(span);

      [
        ["display","inline"],
        ["visibility","visible"],
        ["opacity","1"],
        ["position","relative"],
        ["z-index","9999"],
        ["pointer-events","auto"],
        ["color","inherit"]
      ].forEach(([prop,val])=>{
        a.style.setProperty(prop, val, "important");
      });

      const style = document.createElement("style");
      style.textContent = `
        .sleep {
          display: inline !important;
          visibility: visible !important;
          opacity: 1 !important;
          position: relative !important;
          z-index: 9999 !important;
          pointer-events: auto !important;
          color: inherit !important;
        }
      `;
      document.head.appendChild(style);
    }
  });
});